module.exports = __webpack_public_path__ + "img/upload.971cc2b4.png";